// extracted by mini-css-extract-plugin
module.exports = {"commonContainer":"style_commonContainer__KyABG"};